import React from 'react';
import { PvsCreative } from 'models/interfaces';
import ReactTooltip from 'react-tooltip';
import './PvsCampaignEdit.scss';

interface PvsCreativeListProps {
  creatives: PvsCreative[];
  onCreativeView(x: PvsCreative): void;
  onCreativeEdit(x: PvsCreative): void;
  onCreativeDuplicate(x: PvsCreative): void;
  onCreativeToggleActive(x: PvsCreative): void;
}

const PvsCreativeList: React.FunctionComponent<PvsCreativeListProps> = ({
  creatives,
  onCreativeView,
  onCreativeEdit,
  onCreativeDuplicate,
  onCreativeToggleActive
}) => {
  const syncedTooltipMessage =
    'This creative has been synced with the ad server and cannot be edited.';

  const tryEditCreative = (x: PvsCreative) => onCreativeEdit(x);

  const renderViewIcon = (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
      <title>View</title>
      <path
        d="M23.429 14.654a8.818 8.818 0 0 1-8.822 8.821 8.818 8.818 0 0 1-8.821-8.821 8.818 8.818 0 0 1 8.821-8.822 8.818 8.818 0 0 1 8.822 8.822m.278 7.103c1.625-2.09 2.507-4.596 2.507-7.15C26.214 8.2 21.014 3 14.607 3 8.2 3 3 8.2 3 14.607c0 6.407 5.2 11.607 11.607 11.607 2.6 0 5.154-.882 7.15-2.507l4.029 4.029a1 1 0 0 0 1.414 0l.536-.536a1 1 0 0 0 0-1.414l-4.029-4.029z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
  const renderDuplicateIcon = (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
      <title>Duplicate</title>
      <g fill="currentColor" fillRule="evenodd">
        <path
          d="M9.5 5.15V7.1h14.49a1 1 0 0 1 1 1v15.594h2a1 1 0 0 0 1-1V5.15a1 1 0 0 0-1-1H10.5a1 1 0 0 0-1 1z"
          fillRule="nonzero"
        />
        <path d="M21.818 28H6a1 1 0 0 1-1-1V9.912a1 1 0 0 1 1-1h15.818a1 1 0 0 1 1 1V27a1 1 0 0 1-1 1z" />
      </g>
    </svg>
  );
  const renderEditIcon = (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
      <title>Edit</title>
      <path
        d="M5.857 20.878L19.868 6.866l.01-.009 5.265 5.265-14.011 14.012-.01.009-5.265-5.265zm-1.589 1.408l5.446 5.446-.015.004.006.005L2 30l2.259-7.705.005.006.004-.015zM28.091 5.008a3.106 3.106 0 0 1-.001 4.393l-.01.009-.777.777-.517.518-.01.01-5.49-5.491.786-.787.528-.527a3.106 3.106 0 0 1 4.392 0l1.099 1.098z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  );

  const creativeRows = creatives.map((x: PvsCreative) => (
    <tr key={x.pvs_creative_id}>
      <td>
        {x.name}
        {!x.bucket_key ? (
          <span className="creative-name--no-file"> -- NO FILE UPLOADED</span>
        ) : null}
      </td>
      <td>{x.click_url}</td>
      <td>{x.platform_id === 1 ? 'Web' : 'Mobile'}</td>
      <td>{!!x.last_sync_date === true ? 'yes' : ''}</td>
      <td>
        <input
          type="checkbox"
          name="is-active-checkbox"
          id="is-active-checkbox"
          value={!!x.is_active === true ? 'true' : 'false'}
          checked={!!x.is_active === true}
          onChange={() => onCreativeToggleActive(x)}
        />
      </td>
      <td>
        <div className="creative-list__action-container">
          {!x.bucket_key ? (
            <button
              className="btn creative-list__action btn-fix disabled"
              style={{ margin: '0', padding: '0' }}
              onClick={() => alert('This creative cannot be displayed!')}
            >
              {renderViewIcon}
            </button>
          ) : (
            <button
              className="btn creative-list__action btn-fix"
              style={{ margin: '0', padding: '0' }}
              onClick={() => onCreativeView(x)}
            >
              {renderViewIcon}
            </button>
          )}

          <button
            className="btn creative-list__action btn-fix"
            style={{ margin: '0', padding: '0' }}
            onClick={() => onCreativeDuplicate(x)}
          >
            {renderDuplicateIcon}
          </button>
          <ReactTooltip id="creative-list-edit-tooltip" globalEventOff="click" />
          <button
            className="btn creative-list__action"
            style={{ margin: '0', padding: '0' }}
            // data-tip={syncedTooltipMessage}
            // data-for="creative-list-edit-tooltip"
            // data-event={!!x.last_sync_date === true ? 'click' : 'none'}
            onClick={() => tryEditCreative(x)}
          >
            {renderEditIcon}
          </button>
        </div>
      </td>
    </tr>
  ));

  return (
    <React.Fragment>
      {creatives.length > 0 ? (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>File Name</th>
              <th>Click Url</th>
              <th>Platform</th>
              <th>Synced</th>
              <th>Active</th>
              <th className="align-center">Actions</th>
            </tr>
          </thead>
          <tbody>{creativeRows}</tbody>
        </table>
      ) : (
        <p className="pvs-creative__empty">No creatives exist for this campaign yet.</p>
      )}
    </React.Fragment>
  );
};

export default PvsCreativeList;
